// Librairies.
import Vue from 'vue';

// Services.
import { HttpClient } from '../shared/HttpClient';
import { ApiService } from '../services/base/ApiService';

// Stores.
import { SecurityStoreMethods } from '@/store/security/SecurityStore';
import store from '@/store';

// Modèles.
import { UserInfo } from '../shared/models/UserInfo.model';
import { UtilisateurOkta } from '@/shared/models/UtilisateurOkta.model';
import { Result } from '@/shared/models/Result.model';
import axios from 'axios';

export class SecurityService {



    public static setUser(userInfo: UserInfo): void {
        store.commit(SecurityStoreMethods.SET_USERINFO, userInfo);
    }


    /**
     * Initialise le service de sécurité en récupérant les valeurs du store de sécurité.
     */
    public static async init(): Promise<boolean> {
        const userOkta = await this.getUserInfo();

        let result = false;
        // Appel au back pour synchroniser l'utilisateur.
        await HttpClient.axios
            .post<Result<UserInfo>>(
                "Maintenance/SynchroUtilisateur",
                userOkta
            )
            .then((reponse) => {
                result = true;
                this.setUser(reponse.data.data);
            })
            .catch(() => {
                result = false;
            });

        return result;

    }

    /**
     * Authentifie un utilisateur à l'aide d'un couple email/password.
     */
    public static async login(fromUri: string) {
        Vue.prototype.$auth.signInWithRedirect({ originalUri: fromUri });
    }

    /**
     * Déconnexion et redirection de l'utilisateur.
     */
    public static async logout(): Promise<void> {
        // Logout de Okta. try/catch parce que ça peut potentiellement planter.
        try {
            await Vue.prototype.$auth.signOut();

            store.commit(SecurityStoreMethods.SET_USERINFO, undefined);
            store.commit(SecurityStoreMethods.SET_CONNEXION_SUCCESS, false);
            store.commit(SecurityStoreMethods.SET_CONNEXION_EN_COURS, false);
            axios.defaults.headers.common['Authorization'] = '';

        } catch (e: any) {
            console.log(`Erreur lors de la déconnexion : ${e.name} (message : ${e.message})`);
        }

        // Supprime le token des appel à l'api.
        HttpClient.logout();

        // Retour à l'accueil.
        window.location.href = "/";
    }


    /**
     * Retourne vrai si l'utilisateur est connecté, faux sinon.
     */
    public static async isAuthenticated() {
        return Vue.prototype.$auth.isAuthenticated();
    }

    /**
     * Récupère le token okta.
     */
    public static async getAccessToken() {
        return Vue.prototype.$auth.getAccessToken();
    }

    /**
 * Retourne les informations de l'utilisateur courant
 */
    public static async getUserInfo(): Promise<UtilisateurOkta> {
        const profile = await Vue.prototype.$auth.getUser();
        return {
            oktaId: profile.sub,
            prenom: profile.given_name,
            nom: profile.family_name,
            nomComplet: profile.name,
            loginOkta: profile.preferred_username,
            email: profile.email,
        };
    }
}
